import React from "react"
import { ButtonPrimary } from "../../views/atoms/buttons/ButtonPrimary"
import { Button } from "../../views/atoms/buttons/Button"
import { useHistory } from "react-router-dom"

function BankInfoOptionButtons({ needsBankInfo, onExit }) {
  return needsBankInfo ? <ButtonBarNeedsBankInfo onExit={onExit} /> : <ButtonBarDoesntNeedBankInfo onExit={onExit} />
}

const ButtonBarNeedsBankInfo = ({ onExit }) => {
  const history = useHistory()
  const handleUpdateBankDetailsClick = () => {
    history.push("/account#bankdetails")
    onExit()
  }

  return (
    <div className="flex flex-row justify-end">
      <ButtonPrimary className="mr3" onClick={handleUpdateBankDetailsClick} enabled disabledBackgroundColor="black-10">
        Update bank info
      </ButtonPrimary>
      <Button onClick={onExit} outline>
        {"I'll do this later"}
      </Button>
    </div>
  )
}

const ButtonBarDoesntNeedBankInfo = ({ onExit }) => (
  <div className="flex flex-row justify-center">
    <ButtonPrimary onClick={onExit} enabled disabledBackgroundColor="black-10">
      Close
    </ButtonPrimary>
  </div>
)

export { BankInfoOptionButtons }
